<!-- Public Locations start Here -->
<section class="fullWidthCls publicLocations marginAtTop">
  <div class="container-fluid">
    <h2 class="plHeader">Red Hat Individual Exam Locations</h2>
    <p>Red Hat's certification exams are available at {{ numberOfLocations }} locations worldwide.  Select a country below to find the location nearest you.</p>
      <div class="Locations">
        <md-card class="margin">
          <md-card-content>
            <form class="example-form" [formGroup]="form">
              <div class="col s12 m6 l4">
                <div class="errorZoneSec">
                  <md-form-field class="example-full-width">
                    <input type="text" placeholder="Choose a country" mdInput formControlName="searchCountryControl" [mdAutocomplete]="country" [showDropDown]="{model: 'country', scope : this }">
                    <md-autocomplete #country="mdAutocomplete" [displayWith]="_utility.displayFn">
                      <!-- countryFilteredOptions is produced by setDataInComboField -->
                      <md-option *ngFor="let option of countryFilteredOptions | async" [value]="option">
                        {{ option.name }}
                      </md-option>
                    </md-autocomplete>
                  </md-form-field>
                </div>
              </div>
              <div class="col s12 m6 l4">
                <div class="button-row">
                  <button
                    md-raised-button class="glbAdminBtnCls1" (click)="onSearchBtnClick()">
                    <i class="material-icons">&#xE8B6;</i>SEARCH</button>
                </div>
              </div>
            </form>
          </md-card-content>
        </md-card>
      <!-- end Locations -->
      </div>
      <div class="plAddresses">
        <div class="plAddress" *ngFor="let location of filteredLocations">
          <div class="card-content">
            <h4 class="plHeader">{{ location.code }}</h4>
            <div class="plStreet">{{ location.address1 }}</div>
            <div class="plStreet">{{ location.address2 }}</div>
            <div class="plCity">
              {{ location.city }}, 
              <span class="plState" *ngIf='countriesToShowStates.includes(location.country)'>
                {{ location.state }} 
              </span>
              {{ location.zipCode }}
            </div>
            <div class="plCountry">{{ location.country }}</div>
            <div class="plContact">Contact: {{ location.contactNumber }}</div>
          </div>
        </div>
      </div>
      <div>
        <p><a href="https://www.redhat.com/en/services/training/all-courses-exams/?f%5B0%5D=taxonomy_training%3AExam">Ready to test?</a></p>
        <p><a href="https://www.redhat.com/en/services/training/all-courses-exams">Need to train first?</a></p>
      </div>
    </div>
  <!-- end container-fluid -->
</section>
<!-- end Public Locations section-->



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/public-locations/public-locations.component.html